const replaceQuotes = /["']/g;

export { replaceQuotes };